/* */ 
module.exports = require('./$.hide');
